/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'

import ImageIncludedTextComponent from '../TestimonialComponents/MediaAndTextComponent'
import FullWidthImage from '../TestimonialComponents/ImageTestimonial'
import TextTestimonial from '../TestimonialComponents/TextTestimonial'

import TestimonialVideoCard from '../TestimonialComponents/VideoTestimonial'
import { MobileTestimonialSectionContainer } from './styledComponents'

class MobileTestimonialSection extends Component {
  render() {
    return (
      <MobileTestimonialSectionContainer>
        <TestimonialVideoCard
          id={'ibCricketInPeoplesWords'}
          thumbnailUrl={
            'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/people-about-ibcricket.png'
          }
          videoAltText="The Crazy experience of Virtual reality Cricket - iB Cricket Video"
          videoId={'0xDt7sc9SS4'}
        />
        <FullWidthImage
          draggable={false}
          imageUrl={
            'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/president-plays-cricket.png'
          }
          alt={'altText'}
        />
        <TextTestimonial
          textTestimonialHeading={'Shri Ram Nath Kovind'}
          textTestimonialContent={
            'The President of India playing the first ball of iB Cricket'
          }
          fillHeight
          isDark
        />
        <ImageIncludedTextComponent
          altText="iB Cricket Arcade - Fun and Gaming with friends"
          imageUrl={
            'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/IT-minister.webp'
          }
          textTestimonialHeadingWithoutH2={'Shri Ravi Shankar Prasad'}
          textTestimonialContent={`Union Electronics & IT Minister Shri Ravi Shankar Prasad signing and unveiling the custom-made electronic bat.`}
        />
        <FullWidthImage
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/v2/family-playing-ib-cricket.png"
          alt={'iB Cricket for Everyone'}
        />
        <ImageIncludedTextComponent
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/actor-karthikeya-crazy-experience-with-ib-cricket.webp"
          isVideo
          id={'theCrazyExperienceOfVrCricketIbCricketVideo'}
          videoAltText="The Crazy experience of Virtual reality Cricket - iB Cricket Video"
          videoId={'Am8T0yHoBVQ'}
          textTestimonialHeadingWithoutH2={'Anyone Can Enjoy'}
          textTestimonialContent={`Equal fun for amateurs and  pros, I keep coming back to it because it’s so challenging.`}
          ImageCustomWidth="48.3%"
          TextTestimonialCustomWidth="48.3%"
        />
        <ImageIncludedTextComponent
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileKidPlaying.webp"
          textTestimonialHeading={'OH MY GOD!! \n What a game!'}
          textTestimonialContent={`This is as close as you can get to playing real cricket in the stadium from your bedroom.`}
          alignRowReverse
          isDark
          ImageCustomWidth="48.3%"
          TextTestimonialCustomWidth="48.3%"
        />
        <ImageIncludedTextComponent
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/girl-playing-ib-cricket.png"
          textTestimonialHeading={'Easy to adapt'}
          textTestimonialContent={`Marvellous! I haven't played cricket till now, but I could very easily adapt to iB Cricket. I hit a boundary in first few balls!`}
          ImageCustomWidth="48.3%"
          TextTestimonialCustomWidth="48.3%"
        />
        <FullWidthImage
          altText=""
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/v2/corporates-playing-ib-cricket.png"
        />

        <FullWidthImage
          altText=""
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/families-in-ib-cricket-arcade.png"
        />
        <TextTestimonial
          textTestimonialHeading={'Age is not a barrier'}
          textTestimonialContent={
            "Refreshing experience, I re-lived my childhood. I am thrilled to be able to play iB Cricket, I'll challenge my grandkids now."
          }
          isDark
        />
        <FullWidthImage
          altText="youngsters playing iB Cricket"
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/students-plays-ibcricket.png"
        />
        <ImageIncludedTextComponent
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/girl-playing.png"
          textTestimonialHeading={'More Fun Together'}
          textTestimonialContent={
            'This is the better VR Cricket game compared to everything that is out there today.'
          }
          ImageCustomWidth="48.3%"
          TextTestimonialCustomWidth="48.3%"
        />

        <ImageIncludedTextComponent
          imageUrl="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/v2/man-playing-ib-cricket.png"
          textTestimonialHeadingWithoutH2={'A Game Changer'}
          textTestimonialContent={`Every aspect is very captivating.I see a lot of potential for iB Cricket. It will be a game changer in entertainment.`}
          ImageCustomWidth="48.3%"
          TextTestimonialCustomWidth="48.3%"
          alignRowReverse
        />
      </MobileTestimonialSectionContainer>
    )
  }
}

export default MobileTestimonialSection



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/MobileTestimonialSection/index.js